export default "__VITE_ASSET__B1lsX_T9__"